import PropTypes from 'prop-types';
import React from 'react';
import { cymbioColors } from '../../../utils/colors';

const strokeColor = cymbioColors.analytics.textSecondary;

export function FunnelIcon({ color = strokeColor }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33203 3.33301H16.6654V5.14301C16.6653 5.585 16.4896 6.00885 16.177 6.32134L12.4987 9.99967V15.833L7.4987 17.4997V10.4163L3.76536 6.30967C3.48657 6.00295 3.33208 5.60334 3.33203 5.18884V3.33301Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

FunnelIcon.propTypes = {
  color: PropTypes.string,
};
